import { Coords } from "google-map-react"

export type GeoLocation = {
    lat: number
    lon: number
}
export type ILocation = {
    geoLocation: GeoLocation
    locationAddress: string
}


export const initAutocompleteService = (): google.maps.places.AutocompleteService => {
    if (google?.maps?.places?.AutocompleteService) {
        const autocompleteService = new google.maps.places.AutocompleteService()

        return autocompleteService;
    }

    return undefined as unknown as google.maps.places.AutocompleteService
}
export const initGeocoder = (): google.maps.Geocoder => {
    if (google?.maps?.Geocoder) {
        return new google.maps.Geocoder()
    }

    return undefined as unknown as google.maps.Geocoder
}

const convertAddressToCoords = (address: string, geocoder: google.maps.Geocoder): Promise<Coords> => {
    const promise = new Promise<Coords>((resolve, reject) => {
        if (!geocoder) {
            reject("Geocode was not loaded");
            console.error('Geocode was not loaded')
        } else {
            geocoder.geocode({ address }, function (results, status) {
                if (status === 'OK' && results[0]) {
                    const lat = results[0].geometry.location.lat()
                    const lng = results[0].geometry.location.lng()
                    resolve({ lat, lng })
                } else if(status === "ZERO_RESULTS") {
                    resolve({
                        lat: 0,
                        lng: 0
                    })
                } else {
                    reject("Geocode was not successful for the following reason: " + status);
                }
            });
        }

    })

    return promise
}

export const getLocationFromAddress = async (locationAddress?: string) => {
    if(!locationAddress) {
        return null
    }

    const geocoder = initGeocoder()

    if(!geocoder) {
        return null
    }

    const newCoords: Coords | undefined = await convertAddressToCoords(locationAddress, geocoder)
    
    if(!newCoords){
        return null
    }

    const newGeoLocation: GeoLocation = {
        lat: newCoords.lat,
        lon: newCoords.lng
    }

    const newLocation: ILocation = {
        locationAddress,
        geoLocation: newGeoLocation
    }

    return newLocation
}

const convertCoordsToAddress = (marker: Coords, geocoder: google.maps.Geocoder): Promise<string> => {
    const promise = new Promise<string>((resolve, reject) => {
        if (!geocoder) {
            reject("Geocode was not loaded");
            console.error('Geocode was not loaded')
        } else {
            const latlng = new google.maps.LatLng(marker.lat, marker.lng);

            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK' && results[0]) {
                    resolve(results[0].formatted_address)
                } else {
                    reject("Geocode was not successful for the following reason: " + status);
                }
            });
        }
    })

    return promise
}

export const getLocationAfterChangingMarker = async (newMarker: Coords): Promise<ILocation | null> => {
    try {
        const geocoder = initGeocoder()

        if(!geocoder) {
            return null
        }
    
        const locationAddress: string = await convertCoordsToAddress(newMarker, geocoder)
        const newLocation: ILocation = {
            locationAddress,
            geoLocation: {
                lat: newMarker.lat,
                lon: newMarker.lng
            }
        }

        return newLocation;
    } catch (error) {
        return {
            locationAddress: '',
            geoLocation: {
                lat: newMarker.lat,
                lon: newMarker.lng
            }
        }
    }
}
